import Slider from "../../../../../magnolia-component-library/assets/js/modules/slider";
import Modal from "../../../../../magnolia-component-library/assets/js/utils/classes/Modal";

export default function (el) {
    const modalSliderEl = document.querySelector("#screenshots-modal");
    const slider = Slider(el);

    if (!modalSliderEl || !slider) return;

    const modalSlider = Slider(modalSliderEl);
    const modal = new Modal(el);

    modal.run();

    slider.events.on("indexChanged", (sliderInfo) => {
        modalSlider.goTo(sliderInfo.displayIndex - 1);
    });
}
